import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Fade, Slide } from "react-awesome-reveal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { scrollinit } from "@utils/helper";
import parse from "html-react-parser";
import { renderToString } from "react-dom/server";

const SectionOne: React.FC<any> = (props) => {
  const { data } = props;

  return (
    <>
      <div
        className="blog-section-details check-privcy"
        style={{ marginBottom: "-40px" }}
      >
        <div className="container-fluid">
          <div className="col-12 blog-content" style={{ paddingTop: "10px" }}>
            <h1>KwikEngage’s Privacy Policy</h1>
            <p>
              This document/agreement/understanding is a computer-generated
              electronic record published in accordance with the Information
              Technology Act, 2000 (amended from time to time) and its rules.
            </p>

            <div>
              {/* <h5>KwikCod App - Pricing Terms & Conditions</h5> */}
              <h5>1.Introduction </h5>
              <p>
                This Privacy Policy <b>(“Policy”)</b> outlines how GoExcelsior
                Private Limited( <b>“GoEx”</b> or <b> “we”, “our”, </b>or{" "}
                <b>“us”</b>) collects, uses, shares, and protects your personal
                information when you access or use the GoEx website, mobile
                applications, and services. It does not apply to external
                websites or third-party platforms linked through GoEx, or to
                business entities you may interact with independently of our
                services. Goex doing business as KwikEngage, concerning your
                access to and use of the
                https://www.gokwik.co/product/kwikengage or mobile application
                related, linked, or otherwise connected thereto (collectively,
                the <b>“Platform”</b> )
              </p>

              <p>
                We care about protecting the personal information of our
                customers and visitors who use our Platform, our products or
                services (collectively, our "Users")
              </p>

              <p>
                By using the GoEx Platform, you consent to the collection, use,
                and disclosure of your personal information as described in this
                Policy. If you do not agree, please refrain from accessing or
                using the Platform. Our <b>Terms of Use </b>should be read in
                conjunction with this Policy.
              </p>

              <p>
                It also explains our practices regarding personal data collected
                from merchant website visitors, marketing interactions, and
                merchant’s end customers who access or use our Services.
              </p>

              <p>
                By using our services, visiting our website, or engaging with
                our marketing, you acknowledge and consent to the collection,
                use, and processing of your personal information as described in
                this Privacy Policy and our Terms of Service.
              </p>

              <h5>2. Information We Collect and How We Use It</h5>
              <p>
                We collect personal information such as your name, email, phone
                number, and any other data you voluntarily provide. If you
                integrate third-party services or credentials, such as CRM
                platforms, certain information may be transmitted to GoEx based
                on your authorisation.
              </p>
              <ul>
                <p>We use your information to:</p>
                <li>Provide and improve our services;</li>
                <li>Facilitate transactions;</li>
                <li>Prevent fraud and misuse;</li>
                <li>Send service-related alerts and updates;</li>
                <li>Customise your experience; </li>
                <li>Customise your experience; </li>
              </ul>
              <p>
                We collect only what is necessary for the stated purposes and
                will seek your consent before using the information for any new
                purpose.
              </p>

              <h5>Personal identification information</h5>
              <p>
                We may collect personal identification information from Users in
                a variety of ways, including, but not limited to, when Users
                visit our site, register on the site, and in connection with
                other activities, services, features or resources we make
                available on our Site. Users may be asked for, as appropriate,
                name, email address, mailing address, phone number, credit card
                information. Users may, however, visit our Site anonymously. We
                will collect personal identification information from Users only
                if they voluntarily submit such information to us. Users can
                always refuse to supply personal identification information,
                except that it may prevent them from engaging in certain Site
                related activities.
              </p>

              <h5>Non-personal identification information</h5>
              <p>
                We may collect non-personal identification information about
                Users whenever they interact with our Site. Non-personal
                identification information may include the browser name, the
                type of computer and technical information about Users means of
                connection to our Site, such as the operating system and the
                Internet service provider's utilized and other similar
                information.
              </p>

              <h5>KwikEngage's Business Products:</h5>
              <p>
                We create apps, services, features, APIs, software, that enable
                businesses to interact with their users ("Business Products").
                Partners (the "data controllers") may submit personal
                information about their customers/users to us using our Business
                Products. While Partners decide what information to submit, the
                information under the Partner's control. For more information,
                customers may contact the relevant Partner. We process these
                personal data provided by Partners to provide Business Products
                in accordance with the terms applicable to the relevant Business
                Product and otherwise with the Partners' instructions.
              </p>

              <h5>3. SHARING YOUR PERSONAL INFORMATION</h5>
              <p>
                GoEx may disclose your personal information to third parties
                only as described below, and always in accordance with
                applicable laws and this Privacy Policy:
              </p>

              <p>(a) Authorized Users</p>
              <p>
                Personal information associated with your account may be
                accessible to individuals whom you have authorized to access or
                manage your account. A primary account holder may view personal
                data stored in any sub-account they have authorized. We share
                such data only for legitimate business purposes, including
                service delivery, account management, and relevant marketing
                communications, in accordance with this Privacy Policy.
              </p>

              <p>(b) Intra-Group Sharing (GoEx Corporate Affiliates)</p>
              <p>
                We may share your personal information with other entities
                within the GoEx (or Gokwik, if applicable) corporate group. Such
                sharing facilitates the provision of services, internal business
                operations, and marketing of products or services that may be of
                interest to you. All affiliated entities are contractually
                obligated to process your data in accordance with this Privacy
                Policy. In jurisdictions where your consent is legally required
                for such sharing, we will seek your prior consent before
                proceeding.
              </p>

              <p>(c) Third-Party Partners</p>
              <p>
                We may disclose certain personal data (such as your name, email
                address, or other relevant identifiers) to selected third-party
                partners, including marketing, advertising, and service delivery
                partners, for the following limited purposes:
                <ul>
                  <li>Assisting you in the use of our services;</li>
                  <li>
                    Contacting you with promotional offers or service-related
                    communications;
                  </li>
                  <li>Providing their own services or offerings to you.</li>
                </ul>
                Such partners are contractually restricted from using your
                personal data for any purposes other than those explicitly
                outlined herein. We do not disclose your payment card details to
                such partners. Where required by law, your consent will be
                obtained prior to any such sharing. If you are accessing our
                services through location-masking tools (e.g., VPNs), we may be
                unable to determine jurisdictional consent requirements and act
                accordingly.
              </p>

              <p>
                If we jointly present an offer with any partner, we will make
                clear who is collecting the data and whose privacy policy
                applies.
              </p>

              <p>(d) Third-Party Service Providers and Vendors</p>
              <p>
                We may engage third-party service providers to perform services
                on our behalf, including but not limited to:
                <ul>
                  <li>Customer support,</li>
                  <li>Fraud detection and prevention</li>
                  <li>IT infrastructure and storage,</li>
                  <li>Advertising and marketing support,</li>
                  <li>Analytics and search engine optimization</li>
                </ul>
                Such providers are granted access to your personal information
                strictly on a need-to-know basis and only to the extent required
                to deliver the contracted services. These third parties are
                legally bound to confidentiality and prohibited from using your
                personal data for any other purpose.
              </p>

              <p>
                In cases where you purchase products or services via a GoEx
                platform from a third party, your relevant personal information
                will be shared with that third party to fulfil your order and
                provide associated support.
              </p>

              <p>
                Additionally, we may share non-personally identifiable data
                (e.g., aggregate statistics, usage patterns, open rates, and
                trends) with media, partners, industry analysts, or prospective
                stakeholders for analytical or benchmarking purposes.
              </p>

              <p>
                We may also use third parties to facilitate certain
                communications (e.g., newsletters, surveys), provide
                telecom-related services, or help administer the website. Your
                personal data will be shared for these purposes only, subject to
                applicable legal requirements and your consent where necessary
              </p>

              <p>(e) Legal Compliance and Governmental Requests</p>
              <p>
                We may disclose your personal information where such disclosure
                is reasonably necessary to:
                <ul>
                  <li>
                    Comply with any applicable law, regulation, legal process,
                    or enforceable governmental request;
                  </li>
                  <li>Enforce our terms of service or other agreements;</li>
                  <li>Safeguard the integrity and security of our services;</li>
                  <li>
                    Protect the rights, property, or safety of GoEx, its users,
                    or the general public;
                  </li>
                  <li>
                    Protect the rights, property, or safety of GoEx, its users,
                    or the general public;
                  </li>
                </ul>
                This may include disclosures in response to lawful requests by
                public authorities, including to meet national security or law
                enforcement requirements. Nothing in this Privacy Policy
                restricts any legal rights or objections you may have in
                response to such requests.
              </p>

              <p>(f)Business Transfers</p>
              <p>
                In the event of a merger, acquisition, financing, sale of
                assets, or any other business transfer, your personal
                information may be shared or transferred as part of therelevant
                transaction. We will notify you via email and/or a prominent
                notice on our website if such a transfer occurs, and inform you
                of any choices you may have regarding your information under the
                new ownership.
              </p>

              <h5>4. Security of Data Transmission and Storage</h5>
              <p>
                The transmission of personal information to GoEx through various
                conversational interfaces or communication channels (including
                but not limited to messaging platforms, chatbots, or email) is
                undertaken at the sole discretion and risk of the user. While
                GoEx employs commercially reasonable efforts to protect personal
                data, the security of information transmitted via such channels
                cannot be fully guaranteed. Accordingly, the Company disclaims
                any liability for unauthorized access, loss, or misuse of
                information during transmission.
              </p>
              <p>
                Upon receipt of such information, GoEx shall implement and
                maintain appropriate technical and organizational security
                measures to safeguard personal data from accidental or unlawful
                destruction, loss, alteration, unauthorized disclosure, or
                access. These measures include, but are not limited to,
                encryption, access controls, secure server environments, and
                internal data protection protocols.
              </p>

              <h5>5. Protection of Stored Personal Information</h5>
              <p>
                GoEx follows industry best practices for the secure collection,
                storage, and processing of personal information. We implement
                multiple layers of safeguards designed to prevent unauthorized
                access to, or disclosure of, user data, including usernames,
                passwords, transaction records, and other sensitive information
                processed or stored on our platform.
              </p>

              <p>
                All sensitive or confidential data exchanges between users and
                the GoEx website or platform occur over Secure Socket Layer
                (SSL) encrypted communication channels and are further protected
                with digital signatures, ensuring both data confidentiality and
                authenticity. These controls are regularly reviewed and updated
                to align with evolving security standards and regulatory
                requirements.
              </p>

              <h5>6. Third-Party Websites</h5>
              <p>
                The GoEx platform may contain links to websites, applications,
                or services operated by third parties, including but not limited
                to advertisers, affiliates, sponsors, suppliers, and licensors.
                GoEx does not exercise control over the content, privacy
                practices, or operational policies of such third-party websites
                and disclaims any responsibility or liability for the actions or
                content of such sites. Users are advised that interactions with
                third-party websites are governed exclusively by the terms and
                conditions and privacy policies of those respective websites.
                The inclusion of any link does not imply endorsement by GoEx
              </p>

              <h5>7. Unauthorized Accounts</h5>
              <p>
                In the event that an account or profile is created on the GoEx
                platform without your knowledge or authorization, you are
                advised to promptly notify the customer support team associated
                with the relevant brand or service in order to request removal
                of the unauthorized account or profile.
              </p>

              <h5>8. Retention of Personal Information</h5>
              <p>
                GoEx retains personal information for as long as is reasonably
                necessary to fulfill the purposes for which it was collected,
                including to provide services, comply with legal and regulatory
                obligations, resolve disputes, and enforce agreements.
                Notwithstanding the foregoing, GoEx may retain personal data for
                longer periods where such retention is:
                <ul>
                  <li>
                    Required for compliance with applicable laws or regulatory
                    obligations;
                  </li>
                  <li>
                    Necessary to protect the vital interests of the data subject
                    or another individual;
                  </li>
                  <li>
                    In accordance with the Company’s data retention policy
                  </li>
                </ul>
              </p>

              <h5>9. Your Rights Under Data Protection Laws</h5>
              <p>
                <b> 9.1.</b> Under applicable data protection laws, you may have
                the following rights in relation to your personal data:
              </p>
              <ul>
                <li>Right of access</li>
                <li>Right to rectification</li>
                <li>Right to erasure</li>
                <li>Right to restrict processing</li>
                <li>Right to object to processing</li>
                <li>Right to lodge a complaint with a supervisory authority</li>
                <li>Right to withdraw consent</li>
              </ul>
              <p>
                <b> 9.2.</b> Where our processing of your personal data is based
                on consent or necessary for the performance of a contract, and
                is carried out by automated means, you may request to receive
                your data in a structured, commonly used, and machine-readable
                format. This right does not extend to processing that adversely
                affects the rights or freedoms of others
              </p>
              <p>
                <b> 9.3.</b> If you believe that your personal data has been
                processed unlawfully or in breach of applicable laws, you have
                the right to lodge a complaint with a competent data protection
                authority in your place of residence, workplace, or where the
                breach occurred.
              </p>
              <p>
                <b> 9.4.</b> You may withdraw your consent to data processing at
                any time. Such withdrawal will not affect the lawfulness of data
                processing conducted prior to the withdrawal.
              </p>
              <p>
                <b> 9.5.</b> All requests to exercise your rights under this
                section should be directed in writing to support@gokwik.co
              </p>

              <h5>10. Advertisements</h5>
              <p>
                Advertisements displayed on the GoEx platform may be delivered
                by third-party advertising partners who may use cookies or
                similar tracking technologies to collect non-personal
                identification information for the purpose of delivering
                targeted advertising content. GoEx does not control the use of
                such cookies or data collection technologies by advertisers, and
                this Privacy Policy does not apply to third-party advertising
                practices.
              </p>

              <h5>11. Changes to this Privacy Policy</h5>
              <p>
                Advertisements displayed on the GoEx platform may be delivered
                by third-party advertising partners who may use cookies or
                similar tracking technologies to collect non-personal
                identification information for the purpose of delivering
                targeted advertising content. GoEx does not control the use of
                such cookies or data collection technologies by advertisers, and
                this Privacy Policy does not apply to third-party advertising
                practices.
                <ol>
                  <li>
                    GoEx reserves the right to modify or update this Privacy
                    Policy at its discretion and at any time. Any updates will
                    be published on this page, along with the revised effective
                    date.
                  </li>
                  <li>
                    Users are encouraged to review this Privacy Policy
                    periodically to stay informed of any changes. Continued use
                    of the platform following the posting of amendments
                    constitutes acceptance of those changes.
                  </li>
                  <li>
                    Where required by applicable law, users may be notified of
                    material changes via email or platform-based notifications.
                  </li>
                </ol>
              </p>

              <h5>12. User Acceptance</h5>
              <p>
                By accessing or using the GoEx website or services, you
                expressly acknowledge that you have read, understood, and agree
                to be bound by the terms of this Privacy Policy. If you do not
                agree to the terms herein, you are advised not to use the
                platform. Continued use after changes to the policy have been
                posted constitutes acceptance of those changes.
              </p>

              <h5>13. Compliance with Data Privacy Regulations</h5>
              <p>
                Users, partners, and third parties accessing or using the GoEx
                platform agree not to use its services in any manner that
                violates applicable data protection or privacy laws, including
                but not limited to the Digital Personal Data Protection Act,
                2023 (India), General Data Protection Regulation (GDPR). Users
                are responsible for ensuring that their use of the services does
                not infringe on any rights relating to the privacy, health, or
                financial data of individuals.
              </p>

              <h5>14. Inquiries and Complaints</h5>
              <p>
                For any queries, concerns, or complaints regarding this Privacy
                Policy, data handling practices, or your interactions with GoEx,
                you may contact our support team at:
                <span
                  style={{
                    backgroundColor: "yellow",
                    color: "black",
                    fontWeight: "600",
                  }}
                >
                  support@gokwik.co
                </span>
              </p>

              <h5>15. Grievance Officer (GRO)</h5>
              <p>
                You may contact our designated Grievance Officer for matters
                relating to the processing of personal data at:
                <span
                  style={{
                    backgroundColor: "yellow",
                    color: "black",
                    fontWeight: "600",
                  }}
                >
                  grievance.officer@gokwik.co
                </span>
              </p>

              <h5>16. User Control and Access</h5>
              <p>
                You can access and update your personal information through your
                account settings. You may also choose to delete your data by
                contacting our support team. Upon request, we will delete your
                information unless retention is required by law.
              </p>

              <h5>17. Security Measures</h5>
              <p>
                Your information is protected using industry-standard
                safeguards, including encryption and access controls. Access to
                your data is limited to authorised personnel who require it for
                service delivery. However, internet transmissions are never 100%
                secure, and we disclaim liability for unauthorised interception.
              </p>

              <h5>18. Policy Updates</h5>
              <p>
                This Policy may be revised from time to time. Any changes will
                be effective immediately upon posting. Continued use of the
                Platform after such changes implies acceptance. You are
                responsible for reviewing the Policy periodically to stay
                informed.
              </p>

              <h5>19. Governing Law and Jurisdiction</h5>
              <p>
                This Policy is governed by Indian law. Any disputes arising from
                its application shall be subject to the exclusive jurisdiction
                of the courts in <b>New Delhi, India.</b>
              </p>

              <h5>20. Grievance Redressal</h5>
              <p>
                For feedback, complaints, or inquiries regarding your personal
                information, please contact our <b>Grievance Officer at: </b>
                <span
                  style={{
                    backgroundColor: "yellow",
                    color: "black",
                    fontWeight: "600",
                  }}
                >
                  grievance.officer@gokwik.co
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SectionOne;
